import Button from '@material-ui/core/Button';
import { NEW_ACTION } from 'Modules/ActionsRewrite/components/constants';
import { FC } from 'react';

const NewActionButton: FC = () => {
  return (
    <Button
      color="primary"
      variant="contained"
      classes={{
        root: 'h-[32px] min-h-[32px] px-2 py-1 w-[100px] whitespace-nowrap',
      }}
      style={{ textTransform: 'none' }}
    >
      {NEW_ACTION}
    </Button>
  );
};

export default NewActionButton;
